import { useState, useEffect, useRef } from 'react';
import { TicketOut, EventStatus } from '../api/types';
import { liveStreamManager } from '../services/CatalogStreamManager';

export function useLiveScores(tickets: TicketOut[]) {
  const [liveScores, setLiveScores] = useState<Record<string, EventStatus>>({});
  const activeEventIdsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const ids = new Set<string>();
    tickets.forEach(t => {
      if (t.status === 'open' || t.status === 'accepted') {
        t.legs?.forEach(leg => {
          if (leg.result_status === 'not_resulted' || leg.result_status === 'pending') {
            ids.add(leg.event_id);
          }
        });
      }
    });
    activeEventIdsRef.current = ids;
  }, [tickets]);

  useEffect(() => {
    const hasOpenTickets = tickets.some(t => t.status === 'open' || t.status === 'accepted');

    if (hasOpenTickets) {
      const unsubscribe = liveStreamManager.subscribe((upserts, deletes) => {
        setLiveScores(prev => {
          let next = { ...prev };
          let changed = false;

          for (const eventId of deletes) {
            if (next[eventId]) {
              delete next[eventId];
              changed = true;
            }
          }

          for (const ev of upserts) {
            if (activeEventIdsRef.current.has(ev.event_id) && ev.status) {
              const existing = next[ev.event_id];
              const incomingStatus = ev.status;
              if (!existing || existing.home_score !== incomingStatus.home_score || existing.away_score !== incomingStatus.away_score || existing.clock !== incomingStatus.clock) {
                next[ev.event_id] = incomingStatus;
                changed = true;
              }
            }
          }

          return changed ? next : prev;
        });
      });

      return () => unsubscribe();
    }
  }, [tickets.some(t => t.status === 'open' || t.status === 'accepted')]);

  return liveScores;
}

